import * as React from "react";

function SvgError(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="83"
      height="83"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.0833 41.5001C76.0833 60.5999 60.5999 76.0834 41.5 76.0834C22.4002 76.0834 6.91667 60.5999 6.91667 41.5001C6.91667 22.4002 22.4002 6.91675 41.5 6.91675C60.5999 6.91675 76.0833 22.4002 76.0833 41.5001ZM27.6667 62.2501L41.5 48.4167L55.3333 62.2501L62.25 55.3334L48.4167 41.5001L62.25 27.6667L55.3333 20.7501L41.5 34.5834L27.6667 20.7501L20.75 27.6667L34.5833 41.5001L20.75 55.3334L27.6667 62.2501Z"
        fill="#DB0000"
      />
    </svg>
  );
}

export default SvgError;
